// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Aniversariantes_MensagemconfigPostResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Response contract for POST /aniversariantes/mensagem-config/{franquia_id}
 *
 * Returns the updated birthday message configuration.
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface Aniversariantes_MensagemconfigPostResponseDados {
franquia_id: number
mensagem_aniversariante: string
}

export type Aniversariantes_MensagemconfigPostResponse = ApiResponse<Aniversariantes_MensagemconfigPostResponseDados>;

registerResponseContract('Aniversariantes_MensagemconfigPostResponse', {
  franquia_id:             { type: 'number',  required: true },
  mensagem_aniversariante: { type: 'string',  required: true },
})
